import React from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import styles from "./Form.css";
import { isEmpty } from "lodash";

export default function Form({ year = "", semester = "", submitHandler }) {
  //useForm hook methods
  const {
    register,
    handleSubmit,
    control,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  //form select properties
  const selectSMCUnits = [
    { value: "0", label: "0" },
    { value: "11", label: "0 - 11" },
    { value: "24", label: "12 - 24" },
    { value: "36", label: "25 - 36" },
    { value: "48", label: "37 - 48" },
    { value: "49", label: "49+" },
  ];
  const selectSMC_GPA = [
    { value: "greater", label: "Greater than 3.0" },
    { value: "less", label: "Less than 3.0" },
  ];

  const transcriptUploadLink = "https://forms.gle/u3hNhDmo3fkjhbJf8";

  const formSanitizingHelper = (obj) => {
    if (typeof obj === "undefined" || obj === undefined || obj === null)
      return "";
    if (typeof obj === "object" && obj.constructor === Object) {
      return `${obj.value}: ${obj.label}`;
    } else {
      return obj.map((data) => {
        switch (data) {
          case "mentoring":
            return "mentoring: I have completed more than 30 units and am interested in being an AGS Peer Mentor";
          case "mentee":
            return "mentee: I am new to AGS or SMC and am interested in being paired with an AGS Peer Mentor";
          case "neither":
            return "neither: not interested in peer mentoring ";
          default:
            return "";
        }
      });
    }
  };
  //form validation and submit//
  const formSubmit = (data) => {
    //----validate form data -----
    if (
      data.transcriptUpload.trim() !== "d7516f0c-9020-46f6-981b-1e3816e89d2c"
    ) {
      setError("transcriptUpload", {
        type: "custom",
        message: "file upload confirmation code incorrect",
      });
    } else if (
      data.fullName.replace(" ", "") !== data.signature.replace(" ", "")
    ) {
      setError("signature", {
        type: "custom",
        message: "Signature did match and is required ",
      });
      return;
    } else if (data.confirm_smcStudentId !== data.studentId) {
      setError("confirm_smcStudentId", {
        type: "custom",
        message: "SMC Student ID must Match and required.",
      });
      return;
    } else if (data.peerMentor === false || isEmpty(data.peerMentor)) {
      setError("peerMentor", {
        type: "custom",
        message: "Please select one of the options",
      }); //meetingPreference
      return;
    } else if (
      data.scholarsProgram === false ||
      isEmpty(data.scholarsProgram)
    ) {
      setError("scholarsProgram", {
        type: "custom",
        message: "Please select one of the options",
      });
    } else if (
      data.meetingPreference === false ||
      isEmpty(data.meetingPreference)
    ) {
      setError("meetingPreference", {
        type: "custom",
        message: "Please select one of the options",
      });
    } else {
      clearErrors();

      //--sanitize input for database ----
      const formData = {
        ...data,
        peerMentor: formSanitizingHelper(data.peerMentor),
        smcUnits: formSanitizingHelper(data.smcUnits),
        smcGPA: formSanitizingHelper(data.smcGPA),
        priorAGSmember: formSanitizingHelper(data.priorAGSmember),
      };

      delete formData.signature;
      delete formData.confirm_smcStudentId;
      delete formData.transcriptUpload;

      submitHandler(formData);
    }
  };
  return (
    <div className="container-sm box">
      <h1>
        {year || "2022"} {semester} AGS Application
      </h1>
      <form
        id="contactForm"
        data-sb-form-api-token="API_TOKEN"
        onSubmit={handleSubmit(formSubmit)}
      >
        <div className=".container-fluid">
          <div className="row">
            <div className="mb-3 col">
              <label className="form-label" htmlFor="officialFullName">
                Full Name
              </label>
              <input
                {...register("fullName", { required: true })}
                className="form-control"
                id="fullName"
                type="text"
                placeholder="Full Name"
                data-sb-validations="required"
              />
              {/* we can handle the form error with the react-hok-form library later when we have time */}
              {errors.fullName && <p>Last name is required.</p>}
              <div
                className="invalid-feedback"
                data-sb-feedback="fullName:required"
              >
                Full Name is required.
              </div>
            </div>
            <div className="mb-3 col">
              <label className="form-label" htmlFor="preferredName">
                Preferred Name
              </label>
              <input
                {...register("preferredName")}
                className="form-control"
                id="preferredName"
                type="text"
                placeholder="Preferred Name"
                data-sb-validations="required"
              />
            </div>
          </div>
        </div>
        <div className=".container-fluid">
          <div className="row">
            <div className="mb-3 col">
              <label className="form-label" htmlFor="academicMajor">
                Academic Major
              </label>
              <input
                {...register("academicMajor", { required: true })}
                className="form-control"
                id="academicMajor"
                type="text"
                placeholder="Academic Major"
                data-sb-validations="required"
              />
              <div
                className="invalid-feedback"
                data-sb-feedback="academicMajor:required"
              >
                Academic Major is required.
              </div>
            </div>

            <div className="mb-3 col">
              <label className="form-label d-block">SMC GPA</label>
              <Controller
                rules={{ required: true }}
                name="smcGPA"
                control={control}
                render={({ field }) => (
                  <Select {...field} options={selectSMC_GPA} />
                )}
              />
            </div>
          </div>
        </div>
        <div className=".container-fluid">
          <div className="row">
            <div className="mb-3 col">
              <label className="form-label" htmlFor="studentId">
                SMC Student ID
              </label>
              <input
                {...register("studentId", { required: true })}
                className="form-control"
                id="studentId"
                type="text"
                placeholder="SMC Student ID"
                data-sb-validations="required"
              />
              <div
                className="invalid-feedback"
                data-sb-feedback="studentId:required"
              >
                SMC Student ID is required.
              </div>
            </div>

            <div className="mb-3 col">
              <label className="form-label" htmlFor="confirm_smcStudentId">
                Confirm SMC Student ID
              </label>
              <input
                {...register("confirm_smcStudentId", { required: true })}
                className="form-control"
                id="confirm_smcStudentId"
                type="text"
                placeholder="SMC Student ID"
                data-sb-validations="required"
              />
              {errors.confirm_smcStudentId && (
                <p className="text-warning">
                  {errors.confirm_smcStudentId.message}
                </p>
              )}
            </div>
          </div>
        </div>
        <div className=".container-fluid">
          <div className="row">
            <div className="mb-3 col">
              <label className="form-label" htmlFor="country">
                Country
              </label>
              <input
                {...register("country")}
                className="form-control"
                id="country"
                type="text"
                placeholder="Country"
                data-sb-validations="required"
              />
              <div
                className="invalid-feedback"
                data-sb-feedback="country:required"
              >
                Country is required.
              </div>
            </div>
            <div className="mb-3 col">
              <label className="form-label" htmlFor="city">
                City
              </label>
              <input
                {...register("city")}
                className="form-control"
                id="city"
                type="text"
                placeholder="City"
                data-sb-validations="required"
              />
              <div
                className="invalid-feedback"
                data-sb-feedback="city:required"
              >
                City is required.
              </div>
            </div>
            <div className="mb-3 col">
              <label className="form-label" htmlFor="zipCode">
                Zip code
              </label>
              <input
                {...register("zipCode")}
                className="form-control"
                id="zipCode"
                type="text"
                placeholder="Zip code"
                data-sb-validations="required"
              />
              <div
                className="invalid-feedback"
                data-sb-feedback="zipCode:required"
              >
                Zip code is required.
              </div>
            </div>
          </div>
        </div>
        <div className="mb-3">
          <label className="form-label" htmlFor="smcEmail">
            SMC Student Email
          </label>
          <input
            {...register("smcEmail", { required: true })}
            className="form-control"
            id="smcEmail"
            type="email"
            placeholder="study group(s) or tutoring sessions"
            data-sb-validations=""
          />
        </div>

        <div className="mb-3">
          <label className="form-label" htmlFor="studyGroupTutoring">
            List any course(s) where you have an interest in joining virtual
            study group(s) or tutoring sessions?
          </label>
          <input
            {...register("studyGroup")}
            className="form-control"
            id="studyGroupTutoring"
            type="text"
            placeholder="study group(s) or tutoring sessions"
            data-sb-validations=""
          />
        </div>
        <div className="mb-3">
          <label className="form-label d-block">
            We may form a Peer Mentoring Committee. Please choose one of the
            following, if applicable.
          </label>
          {errors.peerMentor && (
            <p className="text-warning">{errors.peerMentor.message}</p>
          )}
          <div className="form-check">
            <input
              {...register("peerMentor")}
              value="mentoring"
              className="form-check-input"
              id="peerMentor_MENTOR"
              type="checkbox"
              name="peerMentor"
              data-sb-validations=""
            />
            <label className="form-check-label" htmlFor="peerMentor_MENTOR">
              I have completed more than 30 units and am interested in being an
              AGS Peer Mentor
            </label>
          </div>
          <div className="form-check">
            <input
              {...register("peerMentor")}
              value="mentee"
              className="form-check-input"
              id="peerMentor_MENTEE"
              type="checkbox"
              name="peerMentor"
              data-sb-validations=""
            />
            <label className="form-check-label" htmlFor="peerMentor_MENTEE">
              I am new to AGS or SMC and am interested in being paired with an
              AGS Peer Mentor
            </label>
          </div>
          <div className="form-check">
            <input
              {...register("peerMentor")}
              value="neither"
              className="form-check-input"
              id="peerMentor_NA"
              type="checkbox"
              name="peerMentor"
              data-sb-validations=""
            />
            <label className="form-check-label" htmlFor="peerMentor_NA">
              Not Applicable
            </label>
          </div>
        </div>
        <div className="mb-3">
          <label className="form-label d-block">
            Which meeting time will you be able to join the general meeting on
            Thursday?
          </label>
          {errors.meetingPreference && (
            <p className="text-warning">{errors.meetingPreference.message}</p>
          )}
          <div className="form-check form-check-inline">
            <input
              value="morning"
              {...register("meetingPreference")}
              className="form-check-input"
              id="meetingPreference_MORNING"
              type="checkbox"
              name="meetingPreference"
              data-sb-validations="required"
            />
            <label
              className="form-check-label"
              htmlFor="meetingPreference_MORNING"
            >
              11:15 AM to 12:35 PM
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              {...register("meetingPreference")}
              value="evening"
              className="form-check-input"
              id="meetingPreference_EVENING"
              type="checkbox"
              name="meetingPreference"
              data-sb-validations="required"
            />
            <label
              className="form-check-label"
              htmlFor="meetingPreference_EVENING"
            >
              6:00 to 7:20 PM
            </label>
          </div>
          <div
            className="invalid-feedback"
            data-sb-feedback="whichMeetingTimeWillYouBeAbleToJoinTheGeneralMeetingOnThursday:required"
          >
            One option is required.
          </div>
        </div>
        <div className="mb-3">
          <label className="form-label d-block">
            Are you in the EOPS or Guardian Scholars Program?
          </label>
          {errors.scholarsProgram && (
            <p className="text-warning">{errors.scholarsProgram.message}</p>
          )}
          <div className="form-check form-check-inline">
            <input
              value="EOPS"
              {...register("scholarsProgram")}
              className="form-check-input"
              id="scholarsProgram_EOPS"
              type="checkbox"
              name="scholarsProgram"
              data-sb-validations=""
            />
            <label className="form-check-label" htmlFor="scholarsProgram_EOPS">
              EOPS
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              value="Guardian"
              {...register("scholarsProgram")}
              className="form-check-input"
              id="scholarsProgram_Guardian"
              type="checkbox"
              name="scholarsProgram"
              data-sb-validations=""
            />
            <label
              className="form-check-label"
              htmlFor="scholarsProgram_Guardian"
            >
              Guardian Scholars
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              value="Neither"
              {...register("scholarsProgram")}
              className="form-check-input"
              id="scholarsProgram_neither"
              type="checkbox"
              name="scholarsProgram"
              data-sb-validations=""
            />
            <label
              className="form-check-label"
              htmlFor="scholarsProgram_neither"
            >
              Neither
            </label>
          </div>
        </div>
        <div className="mb-3">
          <label className="form-label d-block">
            How many units have you completed at SMC?
          </label>
          <Controller
            rules={{ required: true }}
            name="smcUnits"
            control={control}
            render={({ field }) => (
              <Select {...field} options={selectSMCUnits} />
            )}
          />
        </div>
        <div className="mb-3">
          <label className="form-label d-block">
            Were you a member of SMC AGS?
          </label>
          <Controller
            name="priorAGSmember"
            rules={{ required: true }}
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                options={[
                  { value: "yes", label: "Yes" },
                  { value: "no", label: "No" },
                ]}
              />
            )}
          />
        </div>
        <br />
        <br />
        <hr />

        <div className="mb-5">
          <label className="form-label" htmlFor="transcriptUpload">
            All AGS members are required to upload their unofficial transcript
            to verify their GPA. An SMC club advisor will review your unofficial
            Transcript and AS student fees to verify your membership
            eligibility. Please upload proof of your GPA and AS student payment
            by
            <a
              target="_blank"
              rel="noreferrer"
              href={transcriptUploadLink}
              style={{ textDecoration: "underLine", color: "blue" }}
            >
              {" "}
              submitting this Google form
            </a>{" "}
            to get your file upload confirmation code.{" "}
            <strong>
              Only SMC Advisors are allowed to access these files that you
              upload.
            </strong>
            <br />
            Your file upload confirmation code.
          </label>
          <input
            {...register("transcriptUpload", { required: true })}
            className="form-control"
            id="transcriptUpload"
            type="text"
            placeholder="You will get this code from Google Form after uploading your transcript "
            data-sb-validations="required"
          />
          {errors.transcriptUpload && (
            <p style={{ color: "red" }}>{errors.transcriptUpload.message}</p>
          )}
        </div>

        <div className={`${styles.agreements}`}>
          <div className="mb-4">
            <h3>Agreement</h3>
            <p>
              I have read{" "}
              <a
                target="_blank"
                rel="noreferrer"
                style={{ color: "blue", textDecoration: "underline" }}
                href="http://agssmc.org/resources/forms_and_documents/ags_constitution(Fall22).pdf"
              >
                the AGS constitution
              </a>{" "}
              and am aware of all items in the constitution that apply.
            </p>
            <p>
              I have read the{" "}
              <a
                target="_blank"
                rel="noreferrer"
                style={{ color: "blue", textDecoration: "underline" }}
                href="https://docs.google.com/document/d/1kKDCoIQMUFP6w7n3OXn1gX7-oa9Q4jVt/edit"
              >
                VIVO Orientation Packet
              </a>
            </p>
            <p>
              My $10 scholarship dues is non-refundable. I understand that dues
              are paid at www.paypal.com at agssmc2020@gmail.com, within four
              weeks of submission of this application. In the Memo Line: Write
              your last name, first name, AGS Dues Fall 2022. You can choose to
              "Pay a business" and AGS will pay the transaction fee.
            </p>
            <p>
              I will abide by the{" "}
              <a
                target="_blank"
                rel="noreferrer"
                style={{ color: "blue", textDecoration: "underline" }}
                href="https://www.smc.edu/administration/governance/documents/administrative-regulations/AR_4410_StudentConductRules.pdf"
              >
                SMC Code of Conduct
              </a>{" "}
              , and if I violate the Code of Conduct I may be suspended or
              expelled from the club and/or reported to the Campus
              Disciplinarian.
            </p>
            <p>
              I am subject to removal of the club for any misconduct, including
              falsely reporting the completion of hours, socials, or attendance
              at meetings.
            </p>
            <p>
              I will not receive three negative ones (explained at the general
              meetings).
            </p>
            <div>
              <p>
                I will complete these following requirements in order to receive
                an AGS transcript notation. *
              </p>
              <ul>
                <li>
                  Complete Virtual Independent Volunteer Opportunities (VIVOs)
                  hours and Chapter Involvement hours or join a committee and
                  complete all committee requirements
                </li>
                <li>Attend 5 General Meetings</li>
                <li>
                  Attend two AGS Sponsored Socials or attend two SMC Sponsored
                  Workshops
                </li>
                <li>
                  Satisfy the Initial, Continuing, Temporary, or Permanent
                  Membership requirements.
                </li>
              </ul>
            </div>
            <label htmlFor="signature">
              By typing my name below, I agree and aware of all the Agreement
              and the requirements abow. I am confirming that I will comply with
              the AGS club by-laws, SMC Code of Conduct, and agree to all the
              requirements of being an AGS member and to earn an AGS transcript
              notation.
            </label>
            <br />
          </div>

          <div className="mb-3">
            <label className="form-label" htmlFor="signature">
              Signature
            </label>
            <input
              {...register("signature", { required: true })}
              className="form-control"
              id="signature"
              type="text"
              placeholder="Signature MUST match the full name above"
              data-sb-validations="required"
            />
            {errors.signature && (
              <p style={{ color: "red" }}>
                Signature must match your full name and is required.
              </p>
            )}
          </div>
        </div>

        <div className="d-none" id="submitSuccessMessage">
          <div className="text-center mb-3">
            <div className="fw-bolder">Form submission successful!</div>
          </div>
        </div>
        <div className="d-none" id="submitErrorMessage">
          <div className="text-center text-danger mb-3">
            Error sending message!
          </div>
        </div>
        <div className="d-grid">
          {Object.keys(errors).length > 0 && (
            <p className="text-warning">
              There is an error in your form. Please fill the form properly.
            </p>
          )}
          <button
            className="btn btn-primary btn-lg"
            id="submitButton"
            type="submit"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}
